/** Auto-generated from AssistantTurnRequest. DO NOT EDIT. */
export const ASSISTANT_MESSAGE_MAX_LENGTH = 8000 as const;

export const ASSISTANT_EFFORTS = ["low", "medium", "high"] as const;

export const ASSISTANT_TURN_MODES = ["intake", "report"] as const;

export const ASSISTANT_INTAKE_PHASES = ["scoping", "revision"] as const;

export const ASSISTANT_INTAKE_KINDS = ["twin_test", "report"] as const;
